import React, { Component } from 'react';
import { Divider, FormGroup, InputGroup, Button, Intent, Switch } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Database extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dbHost: '127.0.0.1',
      dbAccount: 'SRO_VT_ACCOUNT',
      dbShard: 'SRO_VT_SHARD',
      dbUser: 'sa',
      saved: false
    };
  }

  handleSave = (e) => {
    e.preventDefault();
    this.setState({ saved: true });
    setTimeout(() => this.setState({ saved: false }), 3000);
  };

  render() {
    return (
      <SideMenuWrapper>
        <h3 className="display-4 font-italic mb-3" style={{ fontSize: '1.5rem', color: '#182026' }}>
          MS SQL Server Database Configuration
        </h3>
        <p className="text-muted mb-3" style={{ fontSize: '0.85rem' }}>
          Configure database connection strings, SRO Shard/Account connections, and automated backup schedules.
        </p>

        <Divider className="mb-4" />

        {this.state.saved && (
          <div className="alert alert-success py-2 mb-4" style={{ fontSize: '0.85rem' }}>
            Database connection settings saved and verified!
          </div>
        )}

        <form onSubmit={this.handleSave}>
          <div className="row mb-3">
            <div className="col-md-6">
              <FormGroup label="Database Host / IP">
                <InputGroup value={this.state.dbHost} onChange={(e) => this.setState({ dbHost: e.target.value })} />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup label="Database User (SQL Auth)">
                <InputGroup value={this.state.dbUser} onChange={(e) => this.setState({ dbUser: e.target.value })} />
              </FormGroup>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col-md-6">
              <FormGroup label="Account DB Name">
                <InputGroup value={this.state.dbAccount} onChange={(e) => this.setState({ dbAccount: e.target.value })} />
              </FormGroup>
            </div>
            <div className="col-md-6">
              <FormGroup label="Shard DB Name">
                <InputGroup value={this.state.dbShard} onChange={(e) => this.setState({ dbShard: e.target.value })} />
              </FormGroup>
            </div>
          </div>

          <div className="mb-4">
            <Switch label="Enable Connection Pooling (Min 10 / Max 100 Connections)" defaultChecked />
            <Switch label="Automated Daily MS SQL Database Backup at 04:00 AM" defaultChecked />
          </div>

          <Button intent={Intent.PRIMARY} type="submit" icon="database" small text="Save Database Config" />
        </form>
      </SideMenuWrapper>
    );
  }
}
